// @flow

import { getSafeCheckoutPaymentOptions, type OpenedIncomingPayment } from '@tectonics/prs/incoming-payment';

export function getSupportedEwallets(incomingPayment: OpenedIncomingPayment): ImmutableArray<string> {
  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);
  return checkoutPaymentOptions.ewallet;
}
